<!--
 * @Description: 职业认证详情
 * @Date: 2021-03-31 17:26:24
-->
<template>
  <el-form label-width="120px">
    <el-form-item v-for="item in fields" :key="item.label" :label="item.label">
      <img
        style="width: 150px; height: 125px"
        v-if="item.type == 'image'"
        :src="item.value"
        v-amplifyImg="item.value"
      />
      <el-input style="width: 65%" v-else disabled :value="item.value" />
    </el-form-item>
  </el-form>
</template>

<script>
import { certificationDetails } from '@/api/ajax';
const setDataByType = data => {
  let fields = [];
  // 如果存在certificatesNo则表示为当前用户是自动认证，否则人工
  if (data.certificatesNo) {
    fields = [
      {
        label: '证书编码',
        value: data.certificatesNo
      },
      {
        label: '医师姓名',
        value: data.fullName
      },
      {
        label: '省份',
        value: data.provinceName
      },
      {
        label: '医院',
        value: data.organizationName
      }
    ];
  } else {
    fields = [
      {
        label: '医师姓名',
        value: data.fullName
      },
      {
        label: '执业证首页',
        value: data.certificatesZhengUrl,
        type: 'image'
      },
      {
        label: '姓名与注册地址页',
        value: data.certificatesFanUrl,
        type: 'image'
      }
    ];
  }
  return fields;
};
export default {
  name: 'OccupationDetail',
  props: {
    userId: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    return {
      fields: []
    };
  },
  components: {},
  watch: {},
  computed: {},
  methods: {},
  async created() {
    const { pdata } = await certificationDetails({ userId: this.userId });
    this.fields = setDataByType(pdata);
  }
};
</script>

<style scoped lang="scss"></style>
